/* eslint-disable no-case-declarations */
/* eslint-disable no-unused-vars */
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { addDoc, collection, deleteDoc, doc, getDocs, onSnapshot, setDoc } from 'firebase/firestore'
import { firestore, auth } from '../../config/firebase'

let operationsUnsubscribe = null;
let operationsSubscribed = false;

export const startOperationsListener = createAsyncThunk(
  'operations/startListener',
  async (_, { dispatch }) => {
    if (operationsSubscribed) return;
    operationsSubscribed = true;

    const ref = collection(firestore, 'operations');
    operationsUnsubscribe = onSnapshot(ref, (snapshot) => {
      const operationsData = snapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data()
      }));
      
      // Sort by name or creation order
      const sortedOperations = operationsData.sort((a, b) => 
        (a.op_name || '').localeCompare(b.op_name || '')
      );
      
      console.log(`⚡ Operations loaded: ${sortedOperations.length} items`)
      dispatch(setOperations(sortedOperations));
    });
  }
);

export const stopOperationsListener = createAsyncThunk(
  'operations/stopListener',
  async () => {
    if (operationsUnsubscribe) operationsUnsubscribe();
    operationsUnsubscribe = null;
    operationsSubscribed = false;
  }
);

// Keep the old function name for backward compatibility
export const getAllOperations = startOperationsListener;

export const addNewOperation = createAsyncThunk('auth/addNewOperation', async (data) => {
  const { close, ...rest } = data
  try {
    const operationCollection = collection(firestore, 'operations')
    const optimisticData = {
      ...rest,
      creator: auth.currentUser.uid
    }
    await addDoc(operationCollection, optimisticData)
    return optimisticData
  } catch (error) {
    console.log(error)
    throw new Error(error.message) // Handle any errors
  } finally {
    close && close()
  }
})

export const updateOperation = createAsyncThunk('auth/updateOperation', async (data) => {
  const { close, id, ...rest } = data
  try {
    const operationRef = doc(firestore, 'operations', id)
    const optimisticData = {
      ...rest
    }
    await setDoc(operationRef, optimisticData, { merge: true })
    return optimisticData
  } catch (error) {
    console.log(error)
    throw new Error(error.message) // Handle any errors
  } finally {
    close && close()
  }
})

export const deleteOperation = createAsyncThunk('auth/deleteOperation', async (data) => {
  const { close, id } = data
  try {
    const operationRef = doc(firestore, 'operations', id)
    await deleteDoc(operationRef)
    return id
  } catch (error) {
    console.log(error)
    throw new Error(error.message) // Handle any errors
  } finally {
    close && close()
  }
})

const operations = createSlice({
  name: 'operations',
  initialState: {
    operations: [],
    loading: false,
    error: null
  },
  reducers: {
    setOperations: (state, action) => {
      state.operations = action.payload;
      state.loading = false;
    },
    resetOperations: (state) => {
      operationsSubscribed = false;
      state.operations = [];
      state.loading = false;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(startOperationsListener.pending, (state) => {
        state.loading = true
      })
      .addCase(startOperationsListener.fulfilled, (state, action) => {
        state.loading = false
        state.error = null
      })
      .addCase(startOperationsListener.rejected, (state, action) => {
        state.loading = false
        state.error = action.error.message
      })
  }
})

export const { setOperations, resetOperations } = operations.actions
export default operations.reducer
